import { type VariantProps, cva } from "class-variance-authority";
import type { ElementType, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface ContainerProps extends VariantProps<typeof ContainerStyles> {
  as?: ElementType;
  children?: ReactNode;
  className?: string;
}

export const ContainerStyles = cva(null, {
  variants: {
    maxWidth: {
      none: null,
      xl: "max-w-container-xl mx-auto",
      lg: "max-w-container-lg mx-auto",
    },
    padding: {
      x: "px-4",
      l: "pl-4",
      none: null,
    },
  },
  defaultVariants: {
    maxWidth: "xl",
    padding: "x",
  },
});

export const Container = ({
  maxWidth,
  padding,
  as: Element = "div",
  className,
  children,
  ...props
}: ContainerProps): JSX.Element => {
  return (
    <Element
      className={twMerge(ContainerStyles({ maxWidth, padding, className }))}
      {...props}
    >
      {children}
    </Element>
  );
};
